<template>
  <header class="fixed inset-x-0 top-0 z-40">
    <div class="hidden bg-graphite-900 sm:block">
      <div class="mx-auto flex h-9 max-w-7xl items-center justify-end gap-6 px-4 sm:px-6 lg:px-8">
        <a href="tel:+48616682142" class="flex items-center gap-1.5 text-xs font-semibold text-graphite-300 transition-colors hover:text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/></svg>
          +48 616 682 142
        </a>
        <a href="mailto:biuro@monteco.pl" class="flex items-center gap-1.5 text-xs font-semibold text-graphite-300 transition-colors hover:text-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/></svg>
          biuro@monteco.pl
        </a>
      </div>
    </div>

    <div class="border-b-2 border-brand-600 bg-white">
      <div class="mx-auto flex h-24 max-w-7xl items-center justify-between px-4 sm:px-6 sm:h-28 lg:px-8">
        <a href="#top" class="flex items-center" @click="closeMenu">
          <img src="/Images/monteco-logo.png" alt="Monteco" class="h-[72px] w-auto sm:h-[84px]" />
        </a>

        <nav class="hidden items-center gap-9 lg:flex">
          <a
              v-for="link in links"
              :key="link.href"
              :href="link.href"
              class="text-xs font-bold uppercase tracking-wider text-graphite-600 transition-colors hover:text-brand-600"
          >
            {{ link.label }}
          </a>
        </nav>

        <div class="hidden lg:block">
          <a href="#kontakt" class="btn-primary">Zapytaj o wycenę</a>
        </div>

        <button
            type="button"
            class="flex h-10 w-10 items-center justify-center text-graphite-700 lg:hidden"
            aria-label="Otwórz menu"
            @click="menuOpen = !menuOpen"
        >
          <svg v-if="!menuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div v-if="menuOpen" class="border-t border-graphite-100 px-4 py-4 lg:hidden">
        <nav class="flex flex-col gap-1">
          <a
              v-for="link in links"
              :key="link.href"
              :href="link.href"
              class="px-3 py-2.5 text-xs font-bold uppercase tracking-wider text-graphite-700 hover:bg-graphite-50 hover:text-brand-600"
              @click="closeMenu"
          >
            {{ link.label }}
          </a>
          <a href="#kontakt" class="btn-primary mt-2 w-full" @click="closeMenu">Zapytaj o wycenę</a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      menuOpen: false,
      links: [
        { href: '#o-nas', label: 'O nas' },
        { href: '#uslugi', label: 'Usługi' },
        { href: '#dlaczego-my', label: 'Dlaczego my' },
        { href: '#kontakt', label: 'Kontakt' }
      ]
    };
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    }
  }
};
</script>
